<template>
  <div id="tablesSve6Risk" class="mt-5 col-xs-12">
    <!-- TABLAS DE GES -->
    <div v-if="isTable">
      <div class="content-toggle">
        <div class="w-100 align-items-center d-flex">
          <button
            class="mt-0 mr-3 p-0 d-flex align-items-center back"
            @click.prevent="changeTable('opt')"
            :class="{
              ges_active: activeBtn === 'opt',
              ges_inactive: activeBtn === 'adm',
            }"
          >
            <p class="mb-0 d-none d-lg-block label-bold">GES operativos</p>
          </button>

          <button
            class="ml- 2 mt-0 p-0 d-flex align-items-center back"
            @click.prevent="changeTable('adm')"
            :class="{
              ges_active: activeBtn === 'adm',
              ges_inactive: activeBtn === 'opt',
            }"
          >
            <p class="mb-0 d-none d-lg-block label-bold">GES administrativos</p>
          </button>
        </div>
        <div class="d-flex w-100 justify-content-end float-right">
          <button
            @click.prevent="createNewGES()"
            class="button-primary"
            :disabled="loading"
          >
            <span
              >Agregar nuevo GES
              <img class="pl-1 mb-1" src="@/assets/images/icons/add.svg"
            /></span>
          </button>

          <button
            class="button-secundary"
            style="
              margin-left: auto;
              margin-left: 20px;
              position: realtive;
              width: 121px;
              height: 40px;
              border-radius: 100px;
            "
            v-b-toggle.filtroTablesSve
            variant="light"
          >
            <span class="when-opened">
              Filtros
              <img class="pl-0" src="@/assets/images/icons/filter.svg" />
            </span>

            <span class="when-closed">
              Filtros
              <img class="pl-0" src="@/assets/images/icons/filter.svg" />
            </span>
          </button>
        </div>
      </div>

      <!--Filtros-->
      <FilterComponent
        :optionsSVE="optionsSVE"
        @submitFilter="submitFilter"
        :loading="loading"
      />

      <!-- Table Person -->
      <TablePerson
        :dataTable="dataTable"
        :loading="loading"
        :category="category"
        :type="type"
        @deleteItem="deleteItem"
        @onRowSelected="onRowSelected"
        @loadRowsPag="loadRowsPag"
        @editGes="editGes"
        />
    </div>

    <!-- 3 MODAL CREACIÓN y EDICION GES-->
    <ModalCreateGES
      :loading="loading"
      :titleModalGes="titleModalGes"
      :optionsSVE="optionsSVE"
      :record="record"
      @updateTable="updateTable"
    />

    <!-- 4 MODAL Confirmación-->
    <modal-confirm
      :loading="loading2"
      @deleteItem="deleteGes"
      :confirmation="confirmation"
    />

    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success
      :messageModal="messageModal"
      :getUsersNotAdded="getUsersNotAdded"
    />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import Button from "@/components/general/Button";
import { mapActions, mapGetters, mapState } from "vuex";
import FilterComponent from "./components/FilterComponent.vue";
import ModalConfirm from "./modals/ModalConfirm.vue";
import TablePerson from "./components/TablePerson.vue";
import ModalCreateGES from "./modals/ModalCreateGES.vue";
import ModalSuccess from "./modals/ModalSuccess";
import ModalError from "./modals/ModalError";

export default {
  props: {
    risk: Boolean,
    category: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    }
  },
  components: {
    Button,
    ModalCreateGES,
    ModalConfirm,
    FilterComponent,
    TablePerson,
    ModalSuccess,
    ModalError,
  },
  data() {
    return {
      isTable: true,
      titleModalGes: "Agregar nuevo GES",
      typeGes: "",
      activeBtn: "opt",
      optionsGES: [
        { id: "administrative", name: "GES Administrativo" },
        { id: "operative", name: "GES Operativo" },
      ],
      dataTable: {
        rows: [],
        fields: [],
      },
      optionsSVE: [],
      gesInfo: {},
      messageModal: "",
      confirmation: {},
      record: null,
      statusCharacterization: {
        empty: {
          color: "#5D5FEF",
          textcolor: "#5D5FEF",
          text: "Realizar riesgo potencial",
        },
        "Riesgo bajo": {
          textcolor: "#0C9E42",
          icon: "riesgobajo.svg",
          text: "Riesgo Bajo",
        },
        "Riesgo medio": {
          textcolor: "#FF9900",
          icon: "warning_orange.svg",
          text: "Riesgo medio",
        },
        "Riesgo alto": {
          textcolor: "#DA1414",
          icon: "alarm-warning-line.svg",
          text: "Riesgo alto",
        },
        "Por definir en IPT": {
          color: "#FEFFC8",
          icon: "warning_red.svg",
          text: "Por Definir en IPT",
        },
      },
    };
  },
  computed: {
    ...mapState("modSVE", [
      "loading",
      "loading2",
      "error",
      "message",
      "tableGES",
      "ges",
      "sveList",
    ]),
    ...mapGetters("htGes", ["getUsersNotAdded"]),
  },
  beforeMount() {
    const me = this;
    me.typeGes = me.type;
    me.activeBtn = me.type == "operative" ? "opt" : "adm";
    let data = {
      type: me.typeGes,
    };
    me.loadRows(data);
    me.listSVE();
  },
  methods: {
    ...mapActions("modSVE", [
      "actGetGESTable",
      "actDeleteEmployeeGES",
      "actGetGES",
      "actDeleteGES",
      "actGetSVElist",
    ]),
    ...mapActions("htGes", ["indexEmployee", "updateStateEmployee"]),
    async getGes(x) {
      const me = this;
      me.updateStateEmployee();
      me.actGetGES(x).then(async () => {
        me.gesInfo = me.ges;
        await me.indexEmployee({ id: me.gesInfo.id });
      });
    },
    editGes(item) {
      const me = this;
      me.titleModalGes = "Editar GES";
      me.record = {
        id: item.id,
        nameGES: item.name,
        selectedGES: {
          id: item.type_ges,
          name:
            item.type_ges === "administrative"
              ? "GES Administrativo"
              : "GES Operativo",
        },
        sve: {
          id: item.sve_id,
          name: item.sve,
        },
      };
      me.$bvModal.show("modal-create-ges");
    },
    listSVE() {
      this.actGetSVElist().then(() => {
        this.sveList.map((x) => {
          this.optionsSVE.push({
            id: x.id,
            name: x.name,
          });
        });
      });
    },
    onRowSelected(items) {
      this.isTable = false;
      this.getGes(items[0].type.id);
    },
    deleteGes() {
      const me = this;
      me.actDeleteGES(me.ges.id).then(() => {
        if (me.error.message) {
          me.$bvModal.hide("modal-confirm");
          me.$bvModal.show("modal-fail");
        } else {
          me.messageModal = `Has Borrado el GES ${me.ges.name}`;
          me.$bvModal.hide("modal-confirm");
          me.$bvModal.show("modal-success");
          me.backTables();
        }
      });
    },
    loadRowsPag(page = 1) {
      const me = this;
      let data = {
        type: me.typeGes,
        page: page,
      };
      me.loadRows(data);
    },
    async deleteEmployee(ges_id, employee) {
      await this.actDeleteEmployeeGES({ ges_id, employee });
    },
    changeTable(x) {
      const me = this;
      me.activeBtn = x;
      me.typeGes = x == "adm" ? "administrative" : "operative";
      me.$router.push({
        name: "sve",
        params: {
          category: me.category,
          type: me.typeGes,
        },
      });
      let data = {
        type: me.typeGes,
      };
      me.loadRows(data);
    },
    async loadRows(data) {
      const me = this;
      me.actGetGESTable(data).then(() => {
        me.dataTable.fields = [
          {
            key: "name",
            label: "Nombre GES",
          },
          {
            key: "people",
            label: "Total de Personas",
          },
          {
            key: "sve",
            label: "Tipo de SVE",
          },
        ];

        if (me.risk) {
          me.dataTable.fields.push(
            {
              key: "diseases",
              label: "N° enfermedades laborales",
            },
            {
              key: "type",
              label: "Caracterización GES",
            }
          );
        } else {
          me.dataTable.fields.push({
            key: "type",
            label: "Caracterización GES",
          });
          me.dataTable.fields.push({
            key: "created_at",
            label: "Fecha de creación",
          });
        }

        me.dataTable.fields.push({
          label: "",
          key: "view",
          //formatter: "line_deal_name",
          sortable: true,
        });

        me.dataTable.rows = [];
        me.tableGES.data.forEach((x) => {
          me.dataTable.rows.push({
            id: x.id,
            name: x.name,
            sve_id: x.sve_id,
            type_ges: x.type,
            people: x.total_employees,
            diseases: x.total_diseases,
            type:
              x.characterization_code == "" || x.characterization_code == null
                ? ""
                : me.statusCharacterization[x.characterization_code],
            sve: x.sve,
            characterization_code: x.characterization_code,
            created_at: me.$moment(x.created_at).format("DD-MM-YYYY"),
          });
        });
      });
    },
    createNewGES() {
      const me = this;
      me.titleModalGes = "Agregar Nuevo GES";
      me.record = null;
      me.$bvModal.show("modal-create-ges");
    },
    async backTables() {
      const me = this;
      let data = {
        type: me.typeGes,
      };
      me.$router.push({
        name: "sve",
        params: {
          category: me.category,
          type: me.typeGes,
        },
      });
      me.loadRows(data);
      me.isTable = true;
    },
    updateTable(type, message) {
      const me = this;
      me.typeGes = type;
      me.activeBtn = type == "operative" ? "opt" : "adm";
      me.messageModal = message;
      me.backTables();
    },
    deleteItem(id, name) {
      const me = this;
      me.ges.id = id;
      me.gesInfo.name = name;
      me.confirm("delete");
    },
    confirm(x) {
      const me = this;
      if (x == "delete") {
        me.confirmation = {
          type: x,
          text: `¿Estás seguro de eliminar el GES ${me.gesInfo.name}?`,
        };
        me.$bvModal.show("modal-confirm");
        return;
      }
    },
    isFilter(values) {
      if (values) {
        return Object.values(values).some(
          (filter) => filter !== null && filter !== ""
        );
      }

      return false;
    },
    submitFilter(values) {
      const me = this;
      let data = {
        type: me.typeGes,
        page: 1,
      };

      if (me.isFilter(values)) {
        data = { ...data, ...values };
      }
      me.loadRows(data);
    },
    iconCharacterization(code) {
      let status = null;

      if (code === null || code === "") {
        status = {
          color: "#5D5FEF",
          textcolor: "#5D5FEF",
          text: "Realizar riesgo potencial",
        };
      }

      return status;
    },
  },
};
</script>

<style lang="scss">
#tablesSve6Risk {
  margin-bottom: 30px !important;
  .back {
    background-color: white;
    border: none;
  }
  .textButtonColapse {
    border: none;
    padding: 4px 10px;
    font-size: 11px;
    height: 25px;
    border-radius: 10px;
    margin: 5px 0;
  }
  .buttonColapse {
    background: rgba(38, 152, 135, 0.14);
    border: 2px solid #269887;
    color: #269887;
    font-size: 14px;
    border-radius: 100px;
  }
  .btn-create {
    padding: 12px;
    border-radius: 20px;
    background-color: #269887;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    transition: 0.5s;
    span {
      font-size: 30px;
      line-height: 0;
      margin: 0 5px;
      font-weight: 500;
    }
  }
  .buttons-tables {
    margin-bottom: -30px;
  }
  .status {
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 14px;
  }
  .table-views {
    border-radius: 8px;
    padding: 0;
    thead {
      background-color: #eef2fa; //border-radius: 10px;
      border: none;
      th {
        font-size: 14px;
        border: none;
      }
    }
    tr td {
      background-color: white;
      margin: 0;
    }
    .theading {
      padding: 15px 15px;
    }
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  input:checked + .slider {
    background-color: #269887;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #269887;
  }
  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }
  .content-toggle {
    /* _tab variants / horizontal */
    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: center; //padding-left: 40px;
    border: none;
    box-sizing: border-box;
    position: static; //width: 376px;
    height: 56px;
    left: 28px;
    top: 228px;
    /* Inside auto layout */
    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 30px 0px;
    .ges_active {
      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      /* identical to box height, or 133% */
      display: flex;
      align-items: center;
      border-bottom: 1px solid #5d5fef;
      /* CTA/03 */
      p {
        color: #5d5fef;
      }
    }
    .ges_inactive {
      p {
        color: #546e7a;
      }
      &:hover {
        p {
          color: #5d5fef;
        }
        border-bottom: 1px solid #5d5fef;
      }
    }
    .adm {
      /* Auto layout */
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 2px;
      position: static;
      width: 16px;
      height: 16px;
      left: 128px;
      top: 12px;
      /* highlight/info/medium */
      background: #0075ff;
      border-radius: 100px;
      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      line-height: 11px;
      /* identical to box height */
      display: flex;
      align-items: center;
      text-align: center;
      color: #ffffff;
      /* Inside auto layout */
      flex: none;
      order: 2;
      flex-grow: 0;
      margin: 0px 8px;
    }
    .toggle-search {
      /* Auto layout */
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 8px;
      position: static;
      left: 0%;
      right: 0%;
      top: 0%;
      bottom: 0%;
      /* CTA/00 */
      background: #ececff;
      /* CTA/01 */
      //border: 1px solid #C9CAFF;
      //box-sizing: border-box;
      //border-radius: 48px;
      /* Inside auto layout */
      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0px 0px;
    }
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .filtros-open {
    width: 1002px;
  }
  .filtros {
    display: flex;
    width: 100%;
    margin-bottom: 30px !important;
    flex-direction: column;
    box-shadow: 0 0rem 0.5rem rgba(0, 0, 0, 0.175);
    border-radius: 12px;
  }
}

.modal-content .modalsTables {
  .vs__dropdown-toggle {
    font-size: 15px;
    height: 50px;
    padding-left: 10px;
    border-radius: 22px;
    input {
      margin-top: 0px;
      font-family: "Ubuntu";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      /* identical to box height, or 175% */
      display: flex;
      align-items: center;
      /* content/09 */
      color: #263238;
    }
  }
  #loader2 {
    margin: 20px auto;
    z-index: 1;
    width: 100px;
    height: 100px;
    border: 15px solid #f3f3f3;
    border-radius: 50%;
    border-top: 15px solid #8f8f8f;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
  .nav {
    display: inline-flex;
  }
  .nav.nav-tabs {
    border: 1px solid #c9caff !important;
    border-radius: 100px;
    padding: 4px;
  }
  .nav-link.active {
    border: 0 !important;
    background-color: #5d5fef !important;
    border-radius: 50px;
    color: #ffffff !important;
  }
  .nav-link:hover {
    background: #c9caff;
    border: 0 !important;
    border-radius: 50px !important;
    color: black;
  }
  .nav-tabs {
    a {
      color: black;
      padding: 8px 16px;
      border: 0 !important;
      border-radius: 50px !important;
    }
  }
  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px; //border-radius: 10px;
  }
  .input-vp2,
  .input-vp2 {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px; //border-radius: 10px;
    border: solid 1px gray;
  }
  .alert-dismissible .close {
    height: auto;
    padding: 5px;
    border: 0;
  }
  .addEmployee {
    //border-radius: 10px;
    background: none;
    border: none;
    font-size: 14px !important;
    transition: 0.2s;
    height: auto; //padding: 8px 10px;
    margin-left: 10px;
  }
  .addEmployee span:hover {
    //box-shadow: rgba(0, 0, 0, 0.185) 1px 1px 3px;
    font-weight: bold;
  }
  .vs__clear {
    padding: 5px;
    border: none;
    height: auto;
  }
  button.btn-primary {
    background-color: #5d5fef;
    border-color: #5d5fef;
    padding: 5px 10px;
    height: auto;
    border-radius: 8px;
  }
  button.btn-primary-outline {
    background-color: #ffffff;
    border-color: #5d5fef;
    padding: 5px 10px;
    height: auto;
    border-radius: 8px;
  }
  .table-views {
    border-radius: 8px;
    padding: 0;
    thead {
      background-color: #eef2fa; //border-radius: 10px;
      border: none;
      th {
        font-size: 14px;
        border: none;
      }
    }
    .theading {
      padding: 15px 15px;
    }
    td {
      font-size: 12px;
    }
    .deleteWorker {
      cursor: pointer;
    }
    .deleteWorker:hover {
      box-shadow: rgba(0, 0, 0, 0.185) 1px 1px 3px;
    }
  }
  .delete {
    padding: 5px;
    background-color: white;
    border: 1px solid white;
    color: #da1414;
    font-size: 13px;
    border-radius: 15px;
  }
  .delete:hover {
    background-color: white;
    border: 1px solid #da1414;
    color: #da1414;
    transition: 0.5;
  }
}

.content-loader {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1071;
  background-color: #fff;
  opacity: 0.9;
}

.linea {
  //padding: 15px 5px;
  margin-top: 10px;
  border-top: 1px solid #cfd8dc;
  border-image-slice: 1;
}

.card-color {
  display: flex;
  flex-direction: row;
  flex-shrink: initial;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;
  width: 232px;
  height: 68px;
  /* highlight/info/background */
  background: #e6f7ff;
  /* highlight/info/light */
  border: 1.0263px solid #8deaff;
  border-radius: 4px;
  color: #263238 !important;
  /* Inside auto layout */
  order: 0;
  flex-grow: 0;
}

.card-color.gray {
  background: #f6ffed;
  flex-shrink: initial;
  border: 1.0263px solid #c3f0d2;
  border-radius: 4px;
}

.card-color.orange {
  background: #fffbe6;
  flex-shrink: initial;
  border: 1.0263px solid #ffd97c;
  border-radius: 4px;
}

.card-color.red {
  background: #fff1f0;
  flex-shrink: initial;
  border: 1.0263px solid #ffabab;
  border-radius: 4px;
}

.resaltar {
  filter: brightness(2);
  &:hover {
    filter: brightness(1);
  }
}

.resaltar.icondelete {
  filter: brightness(5);
  &:hover {
    filter: brightness(1);
  }
}

#baseline_box_GES:focus-within {
  border-color: #5d5fef;
}

#baseline_box_SVE:focus-within {
  border-color: #5d5fef;
}

#baseline_box_name:focus-within {
  border-color: #5d5fef;
}

.card-header {
  width: 100%; //@errorbackground: #EDF9F0;
  border-bottom: none !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  background: #ececff !important;
  justify-content: left;
  display: flex;
}

.card-header-left {
  /* Neutral / Gray blue light */
  background: #f5f5f5;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  border-bottom: none;
  widows: 100%;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

.card-personalizada {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  position: relative;
  background: #ffffff;
  border: 0px solid #eceff1 !important;
  box-sizing: border-box;
  box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
  border-radius: 12px !important;
  flex: none;
  order: 0;
  flex-grow: 0; //margin: 24px 0px;
}

.modal-content .modalsTables .vs__clear {
  display: none;
}

.modal-content .modalsTables .vs__dropdown-toggle input {
  /* body regular */
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  margin-left: 12px;
  /* identical to box height, or 175% */
  display: flex;
  align-items: center;
  /* content/09 */
  color: #263238;
}

.with-image-left {
  background: url("../../assets/images/icons/ht_icon_search_2_line.svg")
    no-repeat scroll 6px 10px;
  padding-left: 30px;
}

.buscar-ges {
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  position: relative;
  width: 100%;
  height: 44px; //left: 30px;
  margin-top: 24px;
  background: #ffffff;
  /* content/03 */
  border: 1px solid #b0bec5;
  border-radius: 22px;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 1;
  margin: 16px 0px;
}

.buscar-empleado .form-control {
  border: 0px !important;
  font-family: Ubuntu !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 28px !important;
}
.alert-warning-message {
  border: 1px solid #e56401 !important;
  border-radius: 4px !important;
}
.alert-warning-message ul {
  list-style: square !important;
  padding-left: 20px !important;
}

.button_danger_modal {
  display: flex;
  align-items: center;
  background-color: #da1414;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}
</style>
